import styled from 'styled-components';
import { styleForBreakpoints } from '../../../helpers/media-style';
export const InfoWithIconsWrapper = styled.span`
  display: flex;
  align-items: center;
  ${({
  $vertical,
  $fullWidth
}) => $vertical === false ? $fullWidth ? `
          flex-direction: row;
          justify-content: space-between;
        ` : `
          flex-direction: row;
          justify-content: flex-start;
        ` : styleForBreakpoints($vertical, $vertical => $vertical ? `
              flex-direction: column;
              justify-content: flex-start;
            ` : $fullWidth ? `
              flex-direction: row;
              justify-content: space-between;
            ` : `
              flex-direction: row;
              justify-content: flex-start;
            `)}
  ${({
  $fullWidth
}) => $fullWidth ? `width: 100%;` : ''}
`;